module.exports = __webpack_public_path__ + "static/media/stanford-genetics-logo.7aeff05d.svg";